import React, { useEffect, useState } from 'react';

const loadComponent = async loader => {
  const module = await loader();
  return module.default || module;
};

export const ClientOnlyLottie = props => {
  const [Component, setComponent] = useState(null);

  useEffect(() => {
    let mounted = true;

    loadComponent(() => import('lottie-react')).then(loaded => {
      if (mounted) {
        setComponent(() => loaded);
      }
    });

    return () => {
      mounted = false;
    };
  }, []);

  return Component ? <Component {...props} /> : null;
};

export const ClientOnlyPlayer = props => {
  const [Component, setComponent] = useState(null);

  useEffect(() => {
    let mounted = true;

    import('@lottiefiles/react-lottie-player').then(module => {
      if (mounted) {
        setComponent(() => module.Player);
      }
    });

    return () => {
      mounted = false;
    };
  }, []);

  return Component ? <Component {...props} /> : null;
};
